import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { BannerCategoryFragmentDoc } from '../../fragments/__generated__/BannerCategory.generated';
import { SiteImageFragmentDoc } from '../../fragments/__generated__/SiteImage.generated';
import { SiteFooterBlockFragmentDoc } from '../../fragments/__generated__/SiteFooterBlock.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SiteQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SiteQuery = { siteSettings: { id: string, pk: number, copyrightText: string, description: string, headerText: string, keywords: string, managerEmail: string | null, bannerCategories: Array<{ id: string, pk: number, created: any, sortOrder: number, name: string }>, site: { id: string, name: string, images: Array<{ id: string, pk: number, alt: string, description: string, title: string, annotation: string, thumbnailUrl: string | null, mobileThumbnailUrl: string | null, useInSlider: boolean, link: string, buttonTitle: string, categoryId: string | null }>, footerBlocks: Array<{ id: string, pk: number, name: string, links: Array<{ id: string, pk: number, sortOrder: number, linkText: string, linkAddress: string }> }> } } };


export const SiteDocument = gql`
    query Site {
  siteSettings {
    id
    pk
    copyrightText
    description
    headerText
    keywords
    managerEmail
    bannerCategories {
      ...BannerCategoryFragment
    }
    site {
      id
      name
      images {
        ...SiteImageFragment
      }
      footerBlocks {
        ...SiteFooterBlockFragment
      }
    }
  }
}
    ${BannerCategoryFragmentDoc}
${SiteImageFragmentDoc}
${SiteFooterBlockFragmentDoc}`;

/**
 * __useSiteQuery__
 *
 * To run a query within a React component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteQuery(baseOptions?: Apollo.QueryHookOptions<SiteQuery, SiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
      }
export function useSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
export type SiteQueryHookResult = ReturnType<typeof useSiteQuery>;
export type SiteLazyQueryHookResult = ReturnType<typeof useSiteLazyQuery>;
export type SiteQueryResult = Apollo.QueryResult<SiteQuery, SiteQueryVariables>;
export function refetchSiteQuery(variables?: SiteQueryVariables) {
      return { query: SiteDocument, variables: variables }
    }